<template>
  <div class='loader'>
    <div v-if="loading" class="preloader">
      <div class="cssload-speeding-wheel"></div>
    </div>
  </div>
  <div class="main-wrapper pb-4 pt-4">
    <nav v-if="isActive === true" id="breadcrumbs" class="mt-1 mt-sm-3 mt-lg-4 d-inline" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li v-if="isActive === true" class="breadcrumb-item">
            <a @click="isActive = false; trackAction('$click', { text: 'Back to Partners', type: 'breadcrumb' })"><span>&lt; Back to Partners</span></a>
        </li>
        <li v-if="isActive === true" class="breadcrumb-item">
          <span>
            <span itemprop="name">{{partner.value.name}}</span>
          </span>
        </li>
      </ol>
    </nav>
    <div class="container-fluid" v-if="isActive !== true">
      <div class="row">
        <!-- <Sidebar :filters="filters.value" :categories="categories.value" :apiStatus="apiStatus" @query-results="queryResults" @clear-filters="clearFilters"/> -->
        <div class="col-xl-12 col-lg-12 col-md-12 cards-container">
          <div  v-if="!!!apiStatus.appliedFilters['filters'] && !!!apiStatus.appliedTaxon && !searchQuery">
            <HighlightCategories :categories="highlightCategories.value" :apiStatus="apiStatus" @open-modal="openModal"/>
          </div>
          <section class="content-section all-partners-section">
            <div class="d-flex">
              <h4 v-if="!!apiStatus.appliedTaxonDetails && apiStatus.appliedTaxonDetails.name !== undefined" class="d-inline me-4 active-category-name">{{apiStatus.appliedTaxonDetails.name}}</h4>
              <span v-else>
                <h2 class="d-inline me-4 productlist-title">Oyster Partners</h2>
                <p class="mt-3">Oyster partners with industry leaders & innovators to enable the best global employment experience possible</p>
              </span>
              <nav v-if="apiStatus.appliedTaxon || searchQuery" id="breadcrumbs" class="mt-1 mt-sm-3 mt-lg-4 d-inline" aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li v-if="apiStatus.appliedTaxon" class="breadcrumb-item home">
                    <a @click="clearTaxon"><span>All Partners</span></a>
                  </li>
                  <li v-else-if="searchQuery" class="breadcrumb-item home">
                    <a @click="clearSearch"><span>All Partners</span></a>
                  </li>
                  <li v-if="searchQuery" class="breadcrumb-item">
                    <span>
                      <span itemprop="name">{{searchQuery}}</span>
                    </span>
                  </li>
                </ol>
              </nav>
            </div>
            <div class="row">
              <div class="search-and-title col-lg-3">
                <input class="d-inline form-control search-input" type="text" v-model="keyword" placeholder="Search..." @keyup.enter="querySearchResults(keyword); trackAction('$click', { text: keyword, type: 'search' })" />
                <span v-if="searchQuery" class="mx-3">
                  <button class="ms-auto btn btn-secondary btn-sm" @click="clearSearch">Clear Search</button>
                </span>
              </div>
              <div class="filters-and-categories col-lg-6">
                <FiltersCategories :filters="filters.value" :categories="categories.value" :apiStatus="apiStatus" @query-results="queryResults" @clear-filters="clearFilters" @track-action="trackAction"/>
              </div>
              <div class="sort col-lg-3">
                <Sort :apiStatus="apiStatus" @query-results="queryResults" @track-action="trackAction"/>
              </div>
            </div>
            <Cards :partners="partners.value" :pagination="pagination.value" :customers="customers.value" :apiStatus="apiStatus" @query-results="queryResults" @open-modal="openModal" @track-action="trackAction"/>
          </section>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-if="partner && isActive == true" tabindex="-1" :class="{partnervisible: isActive}">
      <div class="row justify-content-center">
        <div class="col-xl-12 col-lg-12 col-md-12 cards-container">
          <PartnerPageBanner :partner="partner.value" @open-lead="openLead" />
          <div class="row">
            <div class="col-xl-9 col-lg-9 col-md-8 col-12 display-grid sections">
              <Description :description="partner.value.description_html" :template="partner.value.template_layout.indexOf('description')"/>
              <DescriptionSectionsList :descriptions="partner.value.description_section_contents" :template="partner.value.template_layout.findIndex(v => v.includes('description_section'))"/>
              <Screenshots :screenshots="partner.value.screenshots" :template="partner.value.template_layout.indexOf('screenshots')" />
              <Pictures :pictures="partner.value.pictures" :template="partner.value.template_layout.indexOf('pictures')"/>
              <Permissions :dataflows="partner.value.permissions" :partnerLogo="partner.value.logo_url" :partnerName="partner.value.name" :companyLogo="marketplaceSettings.value.logo_url" :companyName="marketplaceSettings.value.name" :template="partner.value.template_layout.indexOf('permission')"/>
              <Features :features="partner.value.features" :template="partner.value.template_layout.indexOf('features')"/>
              <Benefits :benefits="partner.value.benefits" :template="partner.value.template_layout.indexOf('benefits')"/>
              <Services :services="partner.value.services" :template="partner.value.template_layout.indexOf('services')"/>
              <NextSteps :nextSteps="partner.value.next_steps" :template="partner.value.template_layout.indexOf('next_steps')"/>
              <Resources :resources="partner.value.resources" :template="partner.value.template_layout.indexOf('resources')"/>
              <TeamMembers :teamMembers="partner.value.team_members" :template="partner.value.template_layout.indexOf('team_members')"/>
              <Testimonials :testimonials="partner.value.testimonials" :template="partner.value.template_layout.indexOf('testimonials')"/>
              <Pricing :pricings="partner.value.pricing_editions" @open-lead="openLead" :template="partner.value.template_layout.indexOf('pricing')"/>
              <Faq :faqs="partner.value.faqs" @track-action="trackAction" :template="partner.value.template_layout.indexOf('faqs')"/>
              <RelatedPartners :relatedPartners="partner.value.associated_partners" :template="partner.value.template_layout.indexOf('related_partners')"/>
              <AssociatedPartners :associatedPartners="partner.value.associated_partners" :template="partner.value.template_layout.indexOf('associated_partners')"/>
            </div>
            <ListingSidebar :partner="partner.value" :categories="categories.value"/>
          </div>
          <div v-if="partner.value.secondary_cta_destination === 'LEAD_BUTTON' || partner.value.cta_destination === 'LEAD_BUTTON'">
            <LeadForm :lead_form="partner.value.lead_form" :lead-visible="leadVisible" :lead-success-visible="leadSuccessVisible" :key="componentKey" :partner="partner.value" :apikey="props.apikey" :company="props.company" @open-lead-success="openLeadSuccess" />
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid"><GeneralDisclaimer /></div>
  </div>
</template>

<script>
import axios from 'axios'
import {onMounted, ref, toRefs, toRef, reactive, computed, watch, readonly, provide} from 'vue'

import Sidebar from './directory/Sidebar.vue'
import ListingSidebar from './listing/Sidebar.vue'
import FiltersCategories from './directory/FiltersCategories.vue'
import Cards from './oyster/Cards.vue'
import Sort from './oyster/Sort.vue'
import HighlightCategories from './directory/HighlightCategories.vue'
import PartnerPageBanner from './oyster/PartnerPageBanner.vue'
import Banner from './listing/Banner.vue'
import Description from './listing/Description.vue'
import DescriptionSections from './listing/DescriptionSections.vue'
import DescriptionSectionsList from './listing/DescriptionSectionsList.vue'
import Screenshots from './oyster/Screenshots.vue'
import Pictures from './listing/Pictures.vue'
import Permissions from './listing/Permissions.vue'
import Features from './listing/Features.vue'
import Benefits from './listing/Benefits.vue'
import Services from './listing/Services.vue'
import NextSteps from './listing/NextSteps.vue'
import Resources from './listing/Resources.vue'
import TeamMembers from './listing/TeamMembers.vue'
import Testimonials from './listing/Testimonials.vue'
import Pricing from './oyster/Pricing.vue'
import Faq from './listing/Faq.vue'
import Details from './listing/Details.vue'
import RelatedPartners from './listing/RelatedPartners.vue'
import AssociatedPartners from './listing/AssociatedPartners.vue'
import LeadForm from './listing/LeadForm.vue'
import CallToActions from './listing/CallToActions.vue'
import VueMultiselect from 'vue-multiselect'
import GeneralDisclaimer from './oyster/GeneralDisclaimer.vue'


export default {
  props: {
    company: String,
    apikey: String,
    customers: String,
    partnerid: String
  },
  components: {
    Sidebar,
    ListingSidebar,
    FiltersCategories,
    Cards,
    Sort,
    HighlightCategories,
    Banner,
    Description,
    DescriptionSections,
    DescriptionSectionsList,
    Screenshots,
    Pictures,
    Permissions,
    Features,
    Benefits,
    Services,
    NextSteps,
    Resources,
    PartnerPageBanner,
    TeamMembers,
    Testimonials,
    Pricing,
    Faq,
    Details,
    RelatedPartners,
    AssociatedPartners,
    LeadForm,
    VueMultiselect,
    CallToActions,
    GeneralDisclaimer,
  },
  setup(props) {
    const marketplaceSettings = reactive([])
    const partners = reactive([])
    const partner = reactive([])
    const partnerId = ref(1)
    const filters = reactive([])
    const categories = reactive([])
    const highlightCategories = reactive([])
    const pagination = reactive([])
    const isActive = ref(false)
    const leadVisible = ref(false)
    const leadSuccessVisible = ref(false)
    const loading = ref()
    const currentPage = ref(1)
    const apiStatus = reactive({
      currentPage: ref(1),
      lastPage: ref(),
      appliedTaxon: ref(),
      appliedTaxonDetails: ref({}),
      appliedFilters: ref({}),
      sortBy: ref(""),
      selectedCategory: ref(),
      selectedFilters: reactive([])
    })
    const customers = reactive({})
    if (props.customers) {
      customers.value = JSON.parse(props.customers)
    }
    const searchQuery = ref("");
    const keyword = ref("");
    const componentKey = ref(0);

    const forceRerender = () => {
      componentKey.value += 1;
    };
    const translations = reactive({});
    translations.value = {
      "back_to_partners": "< Back to Partners",
      "active_integrations": "Active Integrations",
      "partners_title": "Partners",
      "all_partners": "All Partners",
      "clear_search": "Clear Search",
      "back": "Back",
      "active": "Active",
      "settings": "Settings",
      "search": "Search",
      "clear_filters": "Clear Filters",
      "sort_by": "Sort by",
      "associated_partner": "Associated Partners",
      "benefits": "Benefits",
      "configure": "Configure",
      "description": "Description",
      "details": "Details",
      "faq": "FAQ",
      "features": "Features",
      "data": "Data",
      "lead_form_contact": "Contact",
      "close": "Close",
      "submit": "Submit",
      "lead_form_thanks": "Thank you for your interest in",
      "next_steps": "Next Steps",
      "permissions": "Integration Diagrams",
      "pictures": "Pictures",
      "pricing": "Pricing",
      "related_partners": "Related Partners",
      "resources": "Resources",
      "media": "Media",
      "services": "Services",
      "categories": "Categories",
      "filters": "Filters",
      "links": "Links",
      "whitepapers": "Whitepapers",
      "sidebar_details": "Details",
      "team_members": "Our Team",
      "testimonials": "Testimonials",
      "disable": "Disable",
      "enable": "Enable",
    }

    provide('translations', translations.value);

    async function openModal(id) {
      loading.value = true
      partnerId.value = id
      const partnerContent = await axios
            .get(`${props.company}/api/v3/partners/${partnerId.value}?api_key=${props.apikey}`)
      partner.value = partnerContent.data
      isActive.value = !isActive.value
      trackView("$view", { partner: partner.value.name })
      leadVisible.value = false
      window.scrollTo({ top: 0, behavior: "instant" });
      loading.value = false
      populateLeadForm(partner)
    }
    async function openLead() {
      leadVisible.value = true
      forceRerender()
    }
    async function openLeadSuccess() {
      leadVisible.value = false
      leadSuccessVisible.value = true
      forceRerender()
    }
    async function populateLeadForm(partner){
      const lead_form = await axios
          .get(`${props.company}/api/v3/partners/${partner.value.id}/lead_forms?api_key=${props.apikey}`)
      partner.value.lead_form = lead_form.data
    }
    async function filterApplied(name, optionId){
      var option_value_name = '';
      for(var value in filters.value){
        var item = filters.value[value]
        if(item.name == name){
          for(var option in item.option_values){
            var option_value = item.option_values[option]
            if(option_value.id == optionId){
              option_value_name = option_value.name
            }
          }
        }
      }
      trackAction('$click', { text: option_value_name, type: 'filters' })
    }
    async function queryResults() {
      loading.value = true
      let url = `${props.company}/api/v3/partners?store_id=999&api_key=${props.apikey}&include_facets=true&per_page=1600&page=${apiStatus.currentPage}`
      if(apiStatus.appliedTaxon){
        url = url + `&taxon=${apiStatus.appliedTaxon}`
      }
      if(apiStatus.appliedFilters){
        url = url + formatFilters()
      }
      if(apiStatus.sortBy){
        url = url + `&sort_by=${apiStatus.sortBy}`
      }
      trackView("$view", {})
      const resPartnersQuery = await axios
            .get(url)
      partners.value = resPartnersQuery.data.data //GET Partners
      pagination.value = resPartnersQuery.data.links //GET Pagination
      apiStatus.lastPage = new URLSearchParams(pagination.value.last).get('page')
      loading.value = false
    };
    async function clearFilters(){
      apiStatus.appliedTaxon = null
      apiStatus.appliedFilters = {}
      apiStatus.appliedTaxonDetails = {}
      apiStatus.currentPage = 1
      queryResults()
    }
    async function clearTaxon(){
      apiStatus.appliedTaxon = null
      apiStatus.appliedTaxonDetails = {}
      apiStatus.currentPage = 1
      queryResults()
    }
    async function clearSearch(){
      searchQuery.value = ""
      apiStatus.currentPage = 1
      keyword.value = ""
      queryResults()
      trackAction('$click', { text: 'Clear Search', type: 'clear-search' })
    }
    async function querySearchResults(keyword) {
      loading.value = true
      searchQuery.value = keyword
      let url = `${props.company}/api/v3/partners/search/${searchQuery.value}?store_id=999&api_key=${props.apikey}&include_facets=true&per_page=1600&page=${apiStatus.currentPage}`
      if(apiStatus.appliedTaxon){
        url = url + `&taxon=${apiStatus.appliedTaxon}`
      }
      if(apiStatus.appliedFilters){
        url = url + formatFilters()
      }
      if(apiStatus.sortBy){
        url = url + `&sort_by=${apiStatus.sortBy}`
      }
      trackView("$view", {})
      const resPartnersQuery = await axios
            .get(url)
      partners.value = resPartnersQuery.data.data //GET Partners
      pagination.value = resPartnersQuery.data.links //GET Pagination
      loading.value = false
    };

    async function trackAction(action, details){
      var partnerId = ''
      var categoryId = ''
      if(apiStatus.appliedTaxon != undefined && apiStatus.appliedTaxon != ""){
        categoryId = apiStatus.appliedTaxon
      }
      if(isActive.value){
        partnerId = partner.id
      }
      let data = {
          "name": action,
          "time": Date.now()/1000,
          "properties": { "text": details.text, "section": details.type, "partner_id": partnerId, "category_id": categoryId, "inapp": true }
      }
      let config = {
        method: 'POST',
        maxBodyLength: Infinity,
        url: `${props.company}/api/v3/events?api_key=${props.apikey}`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      await axios.request(config)
        .then((response) => {
        })
        .catch((error) => {
        });
    }

    async function trackView(action, details){
      var page = 'homepage'
      var partnerId = ''
      var categoryId = ''
      if(apiStatus.appliedTaxon != undefined && apiStatus.appliedTaxon != ""){
        page = 'category'
        categoryId = apiStatus.appliedTaxon
      }
      if(isActive.value){
        page = 'partner'
        partnerId = partner.value.id
      }
      if(searchQuery.value != undefined && searchQuery.value != ""){
        page = 'search'
      }
      let data = {
          "name": action,
          "time": Date.now()/1000,
          "properties": { "page": page, "partner_id": partnerId, "category_id": categoryId, "inapp": true }
      }
      let config = {
        method: 'POST',
        maxBodyLength: Infinity,
        url: `${props.company}/api/v3/events?api_key=${props.apikey}`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      await axios.request(config)
        .then((response) => {
        })
        .catch((error) => {
        });
    }

    function formatFilters(){
      let res = "";
      for (var key in apiStatus.appliedFilters){
        if(apiStatus.appliedFilters[key] && apiStatus.appliedFilters[key].length > 0){
          res = res + "&" + key + "=" + apiStatus.appliedFilters[key].join(',')
        }
      }
      return res;
    }
    onMounted(async () => {
      loading.value = true
      if(props.partnerid){
        openModal(props.partnerid)
      }
      const resMarketplaceSettings = await axios
            .get(`${props.company}/api/v3/marketplace_layout_settings?api_key=${props.apikey}`)
      marketplaceSettings.value = resMarketplaceSettings.data[0] //GET Marketplace Settings
      const resPartners = await axios
            .get(`${props.company}/api/v3/partners?store_id=999&api_key=${props.apikey}&include_facets=true&per_page=1600&page=${apiStatus.currentPage}`)
      trackView("$view", {})
      const resHighlightCategories = await axios
            .get(`${props.company}/api/v3/taxons/highlights?store_id=999&api_key=${props.apikey}`)
      partners.value = resPartners.data.data //GET Partners
      filters.value = resPartners.data.option_types //GET Filters
      categories.value = resPartners.data.taxonomies //GET Categories
      highlightCategories.value = resHighlightCategories.data //GET Highlight Categories
      pagination.value = resPartners.data.links //GET Pagination
      apiStatus.sortBy = 'a-z'
      apiStatus.lastPage = new URLSearchParams(pagination.value.last).get('page')
      loading.value = false
    });
    return {
      marketplaceSettings,
      partners,
      partner,
      filters,
      categories,
      highlightCategories,
      isActive,
      leadVisible,
      openLeadSuccess,
      leadSuccessVisible,
      pagination,
      currentPage,
      openModal,
      openLead,
      queryResults,
      querySearchResults,
      apiStatus,
      searchQuery,
      customers,
      clearFilters,
      clearTaxon,
      loading,
      formatFilters,
      componentKey,
      clearSearch,
      keyword,
      props,
      trackAction,
      trackView,
      translations
    }
  },
}
</script>

<style>
  @import "bootstrap/dist/css/bootstrap.min.css";
  @import "@/assets/default-styles.css";
  @import "@/assets/oyster-styles.css";
</style>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>